// extracted by mini-css-extract-plugin
module.exports = {"container":"CountUp_container__HJGmu","float":"CountUp_float__DfBxu","final_anchor":"CountUp_final_anchor__KT8Ik","wheel":"CountUp_wheel__DNMrc"};